
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const GetStartedSection: React.FC = () => {
  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h3 className="text-xl font-semibold mb-4 text-primary-blue">How to Get Started</h3>
      <div className="grid md:grid-cols-4 gap-4 mb-6">
        <div className="bg-gray-50 p-4 rounded-lg">
          <div className="flex items-center justify-center h-10 w-10 rounded-full bg-primary-blue text-white mb-3 mx-auto">
            <span className="font-bold">1</span>
          </div>
          <p className="text-center">Sign up for Business Reseller plan</p>
        </div>
        <div className="bg-gray-50 p-4 rounded-lg">
          <div className="flex items-center justify-center h-10 w-10 rounded-full bg-primary-blue text-white mb-3 mx-auto">
            <span className="font-bold">2</span>
          </div>
          <p className="text-center">Set up your domain name</p>
        </div>
        <div className="bg-gray-50 p-4 rounded-lg">
          <div className="flex items-center justify-center h-10 w-10 rounded-full bg-primary-blue text-white mb-3 mx-auto">
            <span className="font-bold">3</span>
          </div>
          <p className="text-center">Configure your pricing plans</p>
        </div>
        <div className="bg-gray-50 p-4 rounded-lg">
          <div className="flex items-center justify-center h-10 w-10 rounded-full bg-primary-blue text-white mb-3 mx-auto">
            <span className="font-bold">4</span>
          </div>
          <p className="text-center">Start marketing your business</p>
        </div>
      </div>
      <div className="text-center mt-8">
        <Link to="/business-reseller-order">
          <Button size="lg" className="bg-primary-blue hover:bg-blue-700">
            Start Your Referral Business
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default GetStartedSection;
